module.exports = __webpack_public_path__ + "static/media/video_5.7eab43fd.mp4";